// @flow
import { createAction } from "redux-act";

export const openHamburgerMenu = createAction("Open Hamburger Menu");
export const closeHamburgerMenu = createAction("Close Hamburger Menu");
export const setPathname = createAction("Set Pathname");